<template>
  <MdbModal
    centered
    elegant
    scrollable
    :show="show"
    @close="$emit('close')"
  >
    <MdbModalHeader :close="false">
      <MdbModalTitle>
        Crear Pago Manual
      </MdbModalTitle>
      <a
        class="close"
        @click="$emit('close')"
      >
        ×
      </a>
    </MdbModalHeader>
    <MdbModalBody>
      <!-- Selector de Tipo de Destinatario -->
      <div class="d-flex justify-content-center mb-3">
        <div
          class="btn-group btn-group-sm"
          role="group"
        >
          <button
            type="button"
            class="btn"
            :class="entityType === 'doctor' ? 'btn-primary' : 'btn-outline-primary'"
            @click="switchEntityType('doctor')"
          >
            Médico
          </button>
          <button
            type="button"
            class="btn"
            :class="entityType === 'institution'
              ? 'btn-primary' : 'btn-outline-primary'"
            @click="switchEntityType('institution')"
          >
            Institución / Pases
          </button>
        </div>
      </div>

      <!-- Buscador de Usuario / Médico -->
      <div
        v-if="entityType === 'doctor'"
        class="mb-4"
      >
        <header class="font-weight-bold text-center mb-2">
          Buscar Médico
        </header>
        <div class="d-flex align-items-center">
          <MdbInput
            v-model="searchTerm"
            label="Nombre completo"
            outline
            class="flex-grow-1 my-0"
            @keyup.enter="searchUser"
          />
          <MdbBtn
            color="primary"
            size="sm"
            class="px-3 py-2 ml-2"
            style="height: 38px; margin-top: 0;"
            :disabled="searching"
            @click="searchUser"
          >
            <FontAwesomeIcon
              v-if="searching"
              :icon="['fas', 'circle-notch']"
              spin
            />
            <FontAwesomeIcon
              v-else
              :icon="['fas', 'search']"
            />
          </MdbBtn>
        </div>
        <div
          v-if="users.length"
          class="list-group mt-2 overflow-auto"
          style="max-height: 180px;"
        >
          <button
            v-for="user in users"
            :key="user.id"
            type="button"
            class="list-group-item list-group-item-action p-2"
            :class="{'active': selectedUser && selectedUser.id === user.id}"
            @click="selectUser(user)"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span>
                {{ user.doctor.fname }} {{ user.doctor.lname }}
              </span>
              <span
                v-if="user.accessUntil"
                class="badge badge-info pill"
              >
                Vence: {{ user.accessUntil.formatted || user.accessUntil }}
              </span>
              <span
                v-else
                class="badge badge-warning pill"
              >
                Sin vencimiento
              </span>
            </div>
            <small class="d-block text-muted">
              {{ user.doctor.identificationType
                ? `${user.doctor.identificationType}-` : '' }}
              {{ user.doctor.identification || 'Sin ID' }}
            </small>
          </button>
        </div>
      </div>

      <!-- Buscador de Institución -->
      <div v-else class="mb-4">
        <header class="font-weight-bold text-center mb-2">
          Buscar Institución
        </header>
        <div class="d-flex align-items-center">
          <MdbInput
            v-model="searchTerm"
            label="Nombre, bCode o RIF"
            outline
            class="flex-grow-1 my-0"
            @keyup.enter="searchInstitution"
          />
          <MdbBtn
            color="primary"
            size="sm"
            class="px-3 py-2 ml-2"
            style="height: 38px; margin-top: 0;"
            :disabled="searching"
            @click="searchInstitution"
          >
            <FontAwesomeIcon
              v-if="searching"
              :icon="['fas', 'circle-notch']"
              spin
            />
            <FontAwesomeIcon
              v-else
              :icon="['fas', 'search']"
            />
          </MdbBtn>
        </div>
        <div
          v-if="institutions.length"
          class="list-group mt-2 overflow-auto"
          style="max-height: 180px;"
        >
          <button
            v-for="inst in institutions"
            :key="inst.id"
            type="button"
            class="list-group-item list-group-item-action p-2"
            :class="{'active': selectedInstitution && selectedInstitution.id === inst.id}"
            @click="selectInstitution(inst)"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="font-weight-bold">
                {{ inst.name }}
              </span>
              <span class="badge badge-primary pill">
                Pases: {{ inst.passesBalance != null ? inst.passesBalance : 0 }}
              </span>
            </div>
            <small class="d-block text-muted">
              Código: {{ inst.bCode || 'N/A' }} | RIF: {{ inst.identification || 'Sin RIF' }}
            </small>
          </button>
        </div>
      </div>

      <div v-if="selectedUser || selectedInstitution">
        <header class="font-weight-bold text-center mb-2">
          Selecciona tus planes
        </header>
        <div class="row">
          <div
            v-for="(sub, i) in subscripciones"
            :key="'s'+i"
            class="col-12 mb-3"
          >
            <div class="d-flex align-items-center mb-2">
              <div class="our-checkbox big-icon-style mr-2">
                <input
                  :id="'plan-'+sub.id"
                  v-model="selectedPlans"
                  type="checkbox"
                  :value="sub.id"
                  @change="!selectedPlans.includes(sub.id) ?
                    $delete(planSelections, sub.id) :
                    $set(planSelections, sub.id, {typeId: '', quantity: 1})"
                >
                <label :for="'plan-'+sub.id" />
              </div>
              <span class="font-weight-bold">
                {{ sub.name }}
              </span>
            </div>

            <div
              v-if="selectedPlans.includes(sub.id) && planSelections[sub.id]"
              class="ml-4 pl-2 border-left"
            >
              <div class="row align-items-center">
                <div class="col-12 col-sm-7">
                  <header class="small text-muted mb-1">
                    Tipo de pago
                  </header>
                  <select
                    v-model="planSelections[sub.id].typeId"
                    class="custom-select custom-select-sm"
                  >
                    <option
                      disabled
                      value=""
                    >
                      Seleccione tipo de pago
                    </option>
                    <option
                      v-for="tipo in sub.types"
                      :key="tipo.id"
                      :value="tipo.id"
                    >
                      {{ tipo.name }}
                    </option>
                  </select>
                  <small
                    v-if="!sub.types || !sub.types.length"
                    class="text-danger d-block mt-1"
                  >
                    No hay tipos de pago configurados
                  </small>
                </div>
                <div class="col-12 col-sm-5 mt-2 mt-sm-0">
                  <header class="small text-muted mb-1">
                    Cantidad
                  </header>
                  <input
                    v-model="planSelections[sub.id].quantity"
                    type="number"
                    min="1"
                    class="form-control form-control-sm"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <header
          v-if="selectedSubTypes.length"
          class="font-weight-bold text-center my-2"
        >
          Moneda
        </header>
        <div class="row">
          <div
            v-for="(price, i) in (selectedSubTypes.length ? selectedSubTypes[0].prices : [])"
            :key="i"
            :class="['our-radio2 col-6',
                     {'col-sm-4': selectedSubTypes[0].prices.length > 2}]"
          >
            <label>
              <input
                v-model="payment.currency"
                type="radio"
                name="paymentPrice"
                :value="price.Currency.name"
                @change="payment.symbol = price.Currency.symbol;
                         payment.code = price.Currency.code;
                         payment.amount = montoCalculado"
              >
              <span />
              {{ price.Currency.name }}
              <p class="d-inline">
                {{ price.Currency.symbol }}
              </p>
            </label>
          </div>
        </div>

        <header
          v-if="subsSeleccionado.paymentMethods"
          class="font-weight-bold text-center my-2"
        >
          Método de pago
        </header>
        <div class="row">
          <div
            v-for="(pm, i) in metodosPagoDisponibles"
            :key="i"
            :class="['our-radio2 col-6',
                     {'col-sm-4': metodosPagoDisponibles.length > 2}]"
          >
            <label>
              <input
                v-model="payment.method"
                type="radio"
                name="paymentMethod"
                :value="pm.name"
              >
              <span />
              {{ pm.name }}
            </label>
          </div>
        </div>

        <div v-if="payment.method">
          <div class="row">
            <div class="col-12">
              <MdbInput
                v-model="payment.reference"
                label="Referencia"
                class="my-2"
                outline
              />
            </div>
            <div class="col-12 col-sm-6">
              <MdbInput
                v-model="payment.amount"
                type="number"
                label="Monto"
                class="my-2"
                outline
              />
            </div>
            <div class="col-12 col-sm-6">
              <MdbInput
                v-model="payment.date"
                type="date"
                label="Fecha"
                class="my-2 outline-date"
                outline
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-around my-3">
        <MdbBtn
          flat
          dark-waves
          icon="times"
          class="flat-bordered"
          @click="$emit('close')"
        >
          Cerrar
        </MdbBtn>
        <BtnLoader
          v-if="selectedUser || selectedInstitution"
          :btn-disabled="btnDisabled || !payment.method"
          btn-title="Crear pago"
          @click="crearPago"
        />
      </div>
    </MdbModalBody>
  </MdbModal>
</template>

<script>
import {
  mdbModal as MdbModal,
  mdbModalHeader as MdbModalHeader,
  mdbModalTitle as MdbModalTitle,
  mdbModalBody as MdbModalBody,
  mdbInput as MdbInput,
  mdbBtn as MdbBtn,
} from 'mdbvue';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import BtnLoader from '@/components/customButtons/BtnLoader.vue';
import gql from 'graphql-tag';
import usersApprovedForModuleGql from '@/graphql/usersApprovedForModule.gql';
import amiiSubsGql from '@/graphql/amiiSubs.gql';
import payAmiiGql from '@/graphql/payAmii.gql';
import userDoctorFragmentGql from '@/graphql/userDoctorFragment.gql';

export default {
  name: 'ModalCrearPago',
  components: {
    MdbModal,
    MdbModalHeader,
    MdbModalTitle,
    MdbModalBody,
    MdbInput,
    MdbBtn,
    FontAwesomeIcon,
    BtnLoader,
  },
  props: {
    show: Boolean,
  },
  data() {
    return {
      entityType: 'doctor',
      searchTerm: '',
      searching: false,
      users: [],
      institutions: [],
      selectedUser: null,
      selectedInstitution: null,
      selectedPlans: [],
      planSelections: {},
      cantidad: 1,
      tasaDolar: 1,
      subsSeleccionado: {},
      subsTypeSeleccionado: {},
      subsTypeId: '',
      subscripciones: [],
      payment: {
        method: '',
        currency: '',
        symbol: '',
        code: '',
        reference: '',
        amount: 0,
        date: new Date().toISOString().split('T')[0],
      },
      btnDisabled: false,
    };
  },
  computed: {
    selectedSubTypes() {
      const types = [];
      this.selectedPlans.forEach((subId) => {
        const selection = this.planSelections[subId];
        if (selection && selection.typeId) {
          const sub = this.subscripciones.find((s) => s.id === subId);
          const type = sub.types.find((t) => t.id === selection.typeId);
          if (type) types.push(type);
        }
      });
      return types;
    },
    metodosPagoDisponibles() {
      if (!this.subscripciones || !this.selectedPlans.length) return [];
      const subWithMethods = this.subscripciones.find((s) =>
        this.selectedPlans.includes(s.id) && s.paymentMethods && s.paymentMethods.length > 0
      );
      return subWithMethods
        ? subWithMethods.paymentMethods.filter((e) => e.currency.code == this.payment.code)
        : [];
    },
    montoCalculado() {
      let total = 0;
      this.selectedPlans.forEach((subId) => {
        const selection = this.planSelections[subId];
        if (selection && selection.typeId) {
          const sub = this.subscripciones.find((s) => s.id === subId);
          if (!sub) return;
          const type = sub.types.find((t) => t.id === selection.typeId);
          if (!type) return;
          const price = type.prices.find((p) => p.Currency.name === this.payment.currency);
          if (price) {
            let itemTotal = price.amount * selection.quantity;
            if (this.payment.code === 'VED') {
              itemTotal *= this.tasaDolar;
            }
            total += itemTotal;
          }
        }
      });
      return Number(total.toFixed(2));
    },
  },
  watch: {
    montoCalculado(val) {
      this.payment.amount = val;
    },
    show(val) {
      if (val) {
        this.getExchangeRate();
        this.getSubscriptions();
      }
    },
  },
  methods: {
    switchEntityType(type) {
      this.entityType = type;
      this.resetForm();
    },
    getExchangeRate() {
      fetch('https://ve.dolarapi.com/v1/dolares/oficial')
          .then((res) => res.json())
          .then((data) => {
            this.tasaDolar = data.promedio;
          })
          .catch((err) => console.error('Error fetching exchange rate:', err));
    },
    getSubscriptions() {
      this.$apollo.query({
        query: gql`${amiiSubsGql}`,
        fetchPolicy: 'no-cache',
      }).then((res) => {
        this.subscripciones = res.data.amiiSubs;
      });
    },
    searchUser() {
      if (this.searchTerm.length < 3) return;
      this.searching = true;
      this.$apollo.query({
        query: gql`
          ${usersApprovedForModuleGql}
          ${userDoctorFragmentGql}
        `,
        variables: {
          module: 'Médicos',
          fullname: this.searchTerm,
        },
        fetchPolicy: 'network-only',
      }).then((res) => {
        this.users = res.data.usersApprovedForModule || [];
        this.searching = false;
      }).catch(() => {
        this.searching = false;
      });
    },
    searchInstitution() {
      if (this.searchTerm.length < 2) return;
      this.searching = true;
      this.$apollo.query({
        query: gql`
          query searchInstitutions($term: String!) {
            institutionsSearch(term: $term) {
              id
              name
              bCode
              identification
              passesBalance
            }
          }
        `,
        variables: { term: this.searchTerm },
        fetchPolicy: 'network-only',
      }).then((res) => {
        this.institutions = res.data.institutionsSearch || [];
        this.searching = false;
      }).catch(() => {
        this.searching = false;
      });
    },
    selectUser(user) {
      this.selectedUser = user;
      this.selectedInstitution = null;
    },
    selectInstitution(inst) {
      this.selectedInstitution = inst;
      this.selectedUser = null;
    },
    crearPago() {
      if (!this.payment.amount || this.payment.amount <= 0) return;

      const items = this.selectedPlans.map((subId) => ({
        subsTypeId: this.planSelections[subId].typeId,
        quantity: Number(this.planSelections[subId].quantity),
      })).filter((item) => item.subsTypeId);

      if (items.length === 0) return;

      const paymentInput = {
        amount: Number(this.payment.amount),
        date: this.payment.date,
        currency: this.payment.currency,
        symbol: this.payment.symbol,
        method: this.payment.method,
        reference: this.payment.reference,
        status: 'Pending',
      };

      const isInstitution = this.entityType === 'institution' && this.selectedInstitution;

      const variables = {
        payment: paymentInput,
        items: items,
        paymentMethodName: this.payment.method,
        moduleName: isInstitution ? 'Instituto' : 'Médicos',
        personId: this.selectedUser ? this.selectedUser.doctor.id : null,
        bCode: isInstitution ? this.selectedInstitution.bCode : null,
        businessId: isInstitution ? this.selectedInstitution.id : null,
      };

      this.btnDisabled = true;
      this.$apollo.mutate({
        mutation: gql`${payAmiiGql}`,
        variables,
      }).then(() => {
        this.btnDisabled = false;
        this.$emit('success');
        this.resetForm();
      }).catch((err) => {
        this.btnDisabled = false;
        console.error(err);
      });
    },
    resetForm() {
      this.selectedUser = null;
      this.selectedInstitution = null;
      this.searchTerm = '';
      this.users = [];
      this.institutions = [];
      this.payment = {
        method: '',
        currency: '',
        symbol: '',
        code: '',
        reference: '',
        amount: 0,
        date: new Date().toISOString().split('T')[0],
      };
      this.cantidad = 1;
      this.selectedPlans = [];
      this.planSelections = {};
      this.subsTypeId = '';
      this.subsSeleccionado = {};
    },
  },
};
</script>
